// extracted by mini-css-extract-plugin
module.exports = {"list":"SkipMenu-list-lOTuy","item":"SkipMenu-item-SaVeo"};